import React from 'react';

import { Box, Divider, Link, Typography } from '@sunwisesoftware/sunwise-ui';
import Papa from 'papaparse';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ReactHookFormFile from 'common/components/form/ReactHookFormFile';
import { DEFAULT_TERMS } from 'common/constants';
import { handleTermsOnCSVFile } from 'common/utils/helpers';

const FileRate = ({ control, setValue }) => {
    const { t } = useTranslation();
    const name = 'file_rate';

    const [productId, fileRate] = useWatch({ control, name: ['id', name] });

    const isNewRecord = !productId;

    const handleData = (data) => {
        const newTerms = handleTermsOnCSVFile(data, DEFAULT_TERMS);
        setValue('parameters.terms', newTerms.selectedTerms);
    };

    const handleOnChangeFilePercentage = (e) => {
        const file = e[0];
        if (!file) return;
        Papa.parse(file, { complete: handleData });
    };

    const downloadLink =
        fileRate && !isNewRecord
            ? fileRate
            : 'https://sunwise-production.s3.amazonaws.com/media/PPA example file.csv';

    return (
        <Box>
            <Typography fontWeight="bold" variant="body2">
                {t('Interest rate configuration file')}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <ReactHookFormFile
                control={control}
                name={name}
                onChange={handleOnChangeFilePercentage}
                setValue={setValue}
            />
            <Link href={downloadLink} target="_blank">
                {t('View attached file')}
            </Link>
        </Box>
    );
};

FileRate.propTypes = {
    control: PropTypes.object,
    setValue: PropTypes.func,
};

export default FileRate;
